<template>
  <svg fill="none" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
    <path
      fill="currentColor"
      clip-rule="evenodd"
      d="M12.4716 5.52851C12.7319 5.78886 12.7319 6.21097 12.4716 6.47132L8.4716 10.4713C8.21125 10.7317 7.78914 10.7317 7.52879 10.4713L3.52876 6.47136C3.26841 6.21101 3.26841 5.7889 3.52875 5.52855C3.7891 5.2682 4.21121 5.26819 4.47156 5.52854L8.00019 9.05711L11.5288 5.52852C11.7891 5.26817 12.2112 5.26816 12.4716 5.52851Z"
      fill-rule="evenodd"
    />
  </svg>
</template>
